import { Injectable } from '@angular/core';

import { IBetslipState } from '../../../../../base/store/state';
import { ITypeBetslip } from '../../../../bet-generation/models';
import { BetslipError } from '../../../errors/betslip-error';
import { BetslipTypeRestrictedValidationService } from './betslip-type-restricted-validation.service';
import { BetslipTypePureValidationComposerService } from './composers/betslip-type-pure-validation-composer.service';

@Injectable()
export class BetslipTypeValidationComposerService {
    constructor(
        private pureValidation: BetslipTypePureValidationComposerService,
        private typeRestrictedValidation: BetslipTypeRestrictedValidationService,
    ) {}

    validate(typeBetslip: ITypeBetslip, state: IBetslipState): BetslipError[] {
        const pureErrors = this.pureValidation.validate(typeBetslip);
        const typeErrors = this.typeRestrictedValidation.validate(typeBetslip, state);

        return [...pureErrors, ...typeErrors];
    }
}
